var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiDiscussion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 23",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-discussion_svg__clip0_2123_68951)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.333,
    y: 0.667,
    width: 12,
    height: 12.667,
    rx: 1,
    fill: "#A8FFF8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.667,
    cy: 15,
    rx: 6,
    ry: 4.333,
    fill: "#CBFF88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h10v8h-4.667l-4 2.667v-3H11V6z",
    fill: "#14454C",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2.333c0-.184.15-.333.333-.333h11.334a.333.333 0 01.333.333v9.334c0 .184-.15.333-.333.333H25v2.333a.333.333 0 01-.518.278L20.566 12h-5.233a.333.333 0 01-.333-.333V2.333zm.667.334v8.666h5c.066 0 .13.02.185.056l3.481 2.322v-2.044a.333.333 0 01.334-.334h1.666V2.667H15.667z",
    fill: "#14454C"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#14454C",
    strokeLinecap: "round",
    d: "M17.5 5.5h7M17.5 8.833h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 5.667h-2.666V14h2v2.667L16.333 14h5",
    stroke: "#14454C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0l.99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99L34.5 0zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99L3.5 16z",
    fill: "#14D1C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-discussion_svg__clip0_2123_68951"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9)",
    d: "M0 0h20v20H0z"
  })))));
}
export default __webpack_public_path__ + "fonts/ai-discussion-ec4f56c4798ec18fc318642d693470fe.svg";
export { SvgAiDiscussion as ReactComponent };